import {Component, OnInit } from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {ActivatedRoute} from '@angular/router';
import {CantonsService} from '../../../../core/services/cantons.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import {Observable} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {NgxSpinnerService} from 'ngx-spinner';
import {FuseDeleteDialogComponent} from "../../../../core/components/delete-dialog/delete-dialog.component";
import {ToastrService } from "ngx-toastr";
import { EventService } from '../../../../core/services/event.service';
@Component({
    selector: 'canton-detail-page',
    templateUrl: './canton-detail.component.html',
    styleUrls: ['./canton-detail.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class CantonDetailComponent implements OnInit {
  canton: any = {};
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    code: new FormControl('', Validators.required),
    countryId: new FormControl('', Validators.required),
    welcomeText: new FormControl('', Validators.required),
  });
  countries = [];
  public img;
  public uploadedImg = null;
  public defaultForm;
  public defaultImg;
  public returnBack;
  public logo;

  constructor ( private route: ActivatedRoute , private cantonService: CantonsService,
               private router: Router ,
               public translate: TranslateService , public dialog: MatDialog , public snackBar: MatSnackBar ,
               private spinner: NgxSpinnerService, public toastr: ToastrService,
               public eventService: EventService) {
    const id = this.route.snapshot.queryParamMap.get('id');
    this.cantonService.getCantonsById(id).subscribe((data: any) => {
      if (data.flag) {
        this.img = data.flag;
        this.logo = data.flag;
        this.defaultImg = this.img;
      }
      this.canton = data;
      this.cantonService.getCountry().subscribe((result: any) => {
        this.countries = result;
        this.initForm(this.canton);
        setTimeout(() => {
          this.spinner.hide();
        } , 500);
      });
    });
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnInit () {
    this.spinner.show();
  }


  initForm (data) {
    this.formGroup.patchValue(data);
    this.formGroup.valueChanges.subscribe((res) => {
      this.canton.name = (res && res.name) ? res.name : '';
      this.canton.flag = this.img;
    });
    this.defaultForm = this.formGroup.value;
  }

  updateCanton (returnToCanton) {
    const data = this.formGroup.value;
    data.file = this.uploadedImg;
    data.id = this.canton.id;
    this.cantonService.addCanton(data).subscribe((res) => {
      this.returnBack = returnToCanton;
      if (res && returnToCanton) {
        this.cantonService.updateSuccess = true;
        this.toastr.success('Region updated', 'Success!');
        this.router.navigate([ './pages/canton' ]);
      }
    });
  }

  deleteCanton () {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cantonService.deleteCanton(this.canton.id).subscribe((res) => {
          this.toastr.success('Region deleted', 'Success!');
          this.router.navigate([ './pages/canton' ]);
        });
      }
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack (): any {
    let dialogRef;
    if (!this.compareForms() && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog'
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.updateCanton(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly' , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms () {
    return _.isEqual(this.formGroup.value , this.defaultForm) && (this.defaultImg === this.img);
  }

  setImg (img) {
    this.uploadedImg = img;
  }
}
